import i18n from "@/core/plugins/i18n";
const { t } = i18n.global;

export const financialSelections = [
  { label: t("fields.government"), value: "government" },
  { label: t("fields.accounting"), value: "accounting" },
  { label: t("fields.banking"), value: "banking" },
  { label: t("fields.finance"), value: "finance" },
  { label: t("fields.insurance"), value: "insurance" },
  { label: t("fields.other"), value: "other" },
];

export const positionSelections = [
  { label: t("fields.director"), value: "director" },
  { label: t("fields.manager"), value: "manager" },
  { label: t("fields.entryLevel"), value: "entry_level" },
  { label: t("fields.other"), value: "other" },
];
